import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    city: "定位中", //当前城市
    cityCode: "", //当前城市编号
    // 首页数据
    activeIndex: 0, //当前屏ID
    nowRoute: "/", //当前路径
    homeSwiper: "", //首页swiper
    // 关于我们
    about: {
      // 锚点链接高度
      bannerH: 0,
      brandH: 0, //品牌故事
      incidentH: 0, //心田花开大事件
      founderH: 0, //创始人
      conceptH: 0, //教学理念
      story_startH: 0, //故事墙
      contactH: 0 //联系我们
    },
    sign: {
      featureH: 0, //特色课程
      downloadH: 0, //应用下载
      fastH: 0 //快速报名
    },
    scroll: 0, //浏览器滚动高度
    address: "", //地图位置
    toconsule: false, //咨询框显示状态
    activeSub: 0, //关于我们子菜单被选中
    signSub: 0 //线下报名子菜单被选中
  },
  mutations: {
    setActiveIndex(state, index) {
      state.activeIndex = index;
      console.log("state.activeIndex:", state.activeIndex);
    },
    setNowRoute(state, newRoute) {
      console.log("lalalal:", newRoute);
      state.nowRoute = newRoute;
      console.log("state.nowRoute:", state.nowRoute);
    },
    setDestinate(state, value) {
      state.about = value;
    },
    setSignDestinate(state, value) {
      state.sign = value;
    },
    setAddress(state, value) {
      state.address = value;
      console.log("地图位置");
    },
    setCity(state, value) {
      state.city = value;
      console.log("当前城市：", state.city);
    },
    setCityCode(state, value) {
      state.cityCode = value;
      console.log("当前城市编号：", state.cityCode);
    },
    setToconsule(state, value) {
      state.toconsule = value;
    },
    setActiveSub(state, value) {
      state.activeSub = value;
    },
    setSignSub(state, value) {
      state.signSub = value;
    },
    setHomeSwiper(state, value) {
      state.homeSwiper = value;
    },
    setScroll(state, value) {
      state.scroll = value;
    }
  },
  actions: {},
  getters: {
    getActiveIndex(state) {
      return state.activeIndex;
    },
    getNowRoute(state) {
      return state.nowRoute;
    },
    getDestinate(state) {
      return state.about;
    },
    getSignDestinate(state) {
      return state.sign;
    },
    getAddress(state) {
      return state.address;
    },
    getCity(state) {
      return state.city;
    },
    getCityCode(state) {
      return state.cityCode;
    },
    getToconsule(state) {
      return state.toconsule;
    },
    getActiveSub(state) {
      return state.activeSub;
    },
    getSignSub(state) {
      return state.signSub;
    },
    getHomeSwiper(state) {
      return state.homeSwiper;
    },
    getScroll(state) {
      return state.scroll;
    }
  },
  modules: {}
});
